import { render, staticRenderFns } from "./BuyBill.vue?vue&type=template&id=4227e44b&scoped=true&"
import script from "./BuyBill.vue?vue&type=script&lang=js&"
export * from "./BuyBill.vue?vue&type=script&lang=js&"
import style0 from "./BuyBill.vue?vue&type=style&index=0&id=4227e44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227e44b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
